import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import {
    MAX_1919,
    MAX_1679,
    MAX_1439,
    MAX_1279,
    MAX_767,
    MAX_479,
} from '~/src/styles/tokens/break-points';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { COLORS } from '~/src/styles/tokens/colors';

const textStyles = css`
    ${FONTS.compact.regular.size17};
    line-height: ${rem(24)};
    color: ${COLORS.textLightSecondary};
`;

export const ReferralProductFooterContainer = styled.footer`
    width: 100%;
    background-color: ${COLORS.backgroundLightPrimary};
    box-shadow: 0 4px ${rem(16)} 0 rgba(0, 0, 0, 0.08), 0 0 ${rem(6)} 0 rgba(0, 0, 0, 0.08);
    padding: ${rem(24)} ${rem(184)};

    ${mediaQuery(
        { maxWidth: MAX_1919 },
        css`
            padding: ${rem(24)} ${rem(160)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1679 },
        css`
            padding: ${rem(24)} ${rem(88)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1439 },
        css`
            padding: ${rem(24)} ${rem(56)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            padding: ${rem(24)} ${rem(40)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: ${rem(10)} ${rem(20)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_479 },
        css`
            display: inline-block;
        `,
    )};
`;

export const ReferralProductFooter = styled.div`
    max-width: ${rem(1550)};
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
`;

export const ReferralProductFooterText = styled.span`
    ${textStyles};
`;

export const ReferralProductFooterAge = styled.span`
	${textStyles};
`;
